<template>
  <v-form ref="createEstimateRepairerForm" v-model="isFormValid" class="rm-drawer-step">
    <div class="rm-drawer-scroll">
      <p required="true" class="custom-label">
        {{ $t('ESTIMATE_REPAIRER.REPAIRER_NUMBER') }}
      </p>
      <v-text-field
        v-model="repairerNumber"
        :placeholder="$t('ESTIMATE_REPAIRER.PLACEHOLDER.REPAIRER_NUMBER')"
        :rules="requiredRules"
        :error-messages="error?.repairerNumber"
        :maxlength="15"
        hide-details="auto"
      />
      <p
        v-html="$t('ESTIMATE_REPAIRER.HINT.REPAIRER_NUMBER').replace(/\n/g, '<br>')"
        class="custom-hint"
      />
    </div>
  </v-form>
</template>

<script>
import EstimateRepairerService from '@/services/EstimateRepairerService'
import Validators from '@/utils/validators'
import { handleResponseError } from '@/utils/toastUtils'

export default {
  props: {
    currentRepairFile: Object
  },
  data() {
    return {
      isFormValid: false,
      loading: false,
      error: null,
      repairerNumber: '',
      requiredRules: Validators.requiredRules
    }
  },
  created() {
    if (this.currentRepairFile?.repairer_support_number) {
      this.repairerNumber = this.currentRepairFile.repairer_support_number
    }
  },
  mounted() {
    this.emitFooterState()
  },
  computed: {
    footerState() {
      return {
        disabled: this.loading || !this.isFormValid,
        loading: this.loading
      }
    }
  },
  watch: {
    footerState: {
      handler() {
        this.emitFooterState()
      },
      deep: true
    },
    repairerNumber(repairerNumber) {
      this.$emit('repairerNumber', repairerNumber)
    }
  },
  methods: {
    emitFooterState() {
      this.$emit('updateFooterState', this.footerState)
    },
    async submit() {
      if (!this.isFormValid) return

      this.loading = true
      try {
        if (this.currentRepairFile?.repairer_estimate) {
          await this.updateRepairerEstimate()
        } else {
          await this.createRepairerEstimate()
        }
        this.$emit('nextStepEstimateInOffer')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    },
    async createRepairerEstimate() {
      const data = {
        repairer_number: this.repairerNumber,
        repair_file_id: this.currentRepairFile.technical_id
      }
      await EstimateRepairerService.createRepairFileRepairerEstimate(data)
    },
    async updateRepairerEstimate() {
      const data = {
        repairer_number: this.repairerNumber,
        repair_file_id: this.currentRepairFile.technical_id,
        repairer_estimate_id: this.currentRepairFile.repairer_estimate.technical_id
      }
      return EstimateRepairerService.updateRepairFileRepairerEstimate(data)
    }
  }
}
</script>
